var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "registry-evidence" },
    [
      _vm.section === "source"
        ? [
            _c("p", { staticClass: "small text-muted" }, [
              _vm._v(
                "Imported and manually entered evidence. Import times do not indicate when the supplier verified a record. All timestamps below use UTC."
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "small" }, [
              _vm._v(
                "Added via " +
                  _vm._s(
                    _vm.record.origin === "manual" ? "manual entry" : "import"
                  ) +
                  " · Created " +
                  _vm._s(_vm.date(_vm.record.created_at))
              ),
            ]),
            _vm._v(" "),
            _c(
              "details",
              { staticClass: "mb-3" },
              [
                _c("summary", [_vm._v("Effective facts and source values")]),
                _vm._v(" "),
                _vm._l(_vm.record.effective, function (fact, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "border-bottom py-2 small" },
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.label(key)))]),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            fact.values
                              ? _vm.address(fact.values)
                              : fact.is_blank
                              ? "Left blank"
                              : _vm.text(fact.value)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.provisional(fact)
                              ? "Initial manual value"
                              : _vm.label(fact.source)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      fact.source === "correction"
                        ? _c("div", [
                            _vm._v(
                              "Source: " + _vm._s(_vm.sourceSummary(fact))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      fact.differing_evidence
                        ? _c("div", { staticClass: "text-warning" }, [
                            _vm._v("Source values differ."),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("details", [
                        _c("summary", [_vm._v("Evidence details")]),
                        _c("pre", [_vm._v(_vm._s(_vm.json(fact)))]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.record.standing
              ? _c("details", { staticClass: "mb-3" }, [
                  _c("summary", [
                    _vm._v("Standing evidence and immutable identity"),
                  ]),
                  _c("pre", [
                    _vm._v(
                      _vm._s(
                        _vm.json({
                          identity: _vm.record.identity,
                          standing: _vm.record.standing,
                        })
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("details", { staticClass: "mb-3" }, [
              _c("summary", [_vm._v("Import provenance")]),
              _c("pre", [
                _vm._v(
                  _vm._s(
                    _vm.json({
                      first_seen: _vm.provenance.first_seen,
                      last_confirmed: _vm.provenance.last_confirmed,
                    })
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(
              _vm.record.source_records || [],
              function (sourceRecord, index) {
                return _c(
                  "div",
                  {
                    key: sourceRecord.id || index,
                    staticClass:
                      "registry-source-record border rounded p-3 mb-3",
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.label(
                            sourceRecord.dataset_kind || sourceRecord.source
                          )
                        ) +
                          " · Source record " +
                          _vm._s(index + 1)
                      ),
                    ]),
                    _vm._v(" "),
                    sourceRecord.contradicted || sourceRecord.variance
                      ? _c("div", { staticClass: "small text-warning" }, [
                          _vm._v("Conflicting values from one source."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "First seen " +
                          _vm._s(_vm.date(sourceRecord.first_seen_at)) +
                          " · Last seen " +
                          _vm._s(_vm.date(sourceRecord.last_seen_at))
                      ),
                    ]),
                    _vm._v(" "),
                    sourceRecord.moved_to_license_id
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-link p-0",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit(
                                  "open-license",
                                  sourceRecord.moved_to_license_id
                                )
                              },
                            },
                          },
                          [_vm._v("Open license this source moved to")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.versionGroups, function (group) {
                      return _c("div", { key: group.key }, [
                        (sourceRecord[group.key] || []).length
                          ? _c(
                              "details",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  open: group.key === "current_versions",
                                },
                              },
                              [
                                _c("summary", [
                                  _vm._v(
                                    _vm._s(group.label) +
                                      " (" +
                                      _vm._s(sourceRecord[group.key].length) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  sourceRecord[group.key],
                                  function (version) {
                                    return _c(
                                      "div",
                                      {
                                        key: version.id,
                                        staticClass:
                                          "small border-top pt-2 mt-2",
                                      },
                                      [
                                        version.asserted_identity
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  version.asserted_identity
                                                    .issuing_state
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.text(
                                                      version.asserted_number ||
                                                        version
                                                          .asserted_identity
                                                          .number
                                                    )
                                                  ) +
                                                  " · " +
                                                  _vm._s(
                                                    _vm.text(version.status_raw)
                                                  ) +
                                                  " · Expiration " +
                                                  _vm._s(
                                                    _vm.text(
                                                      version.expiration_raw
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        version.expiration_malformed
                                          ? _c(
                                              "div",
                                              { staticClass: "text-warning" },
                                              [
                                                _vm._v(
                                                  "Unrecognized expiration date"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.date(version.created_at)
                                            ) +
                                              " · " +
                                              _vm._s(
                                                _vm.label(version.disposition)
                                              )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        version.import_batch_id
                                          ? _c("div", [
                                              _vm._v(
                                                "Import #" +
                                                  _vm._s(
                                                    version.import_batch_id
                                                  ) +
                                                  " · accepted sequence " +
                                                  _vm._s(
                                                    version.accepted_sequence
                                                  ) +
                                                  " · row " +
                                                  _vm._s(version.row_number)
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("details", [
                                          _c("summary", [
                                            _vm._v(
                                              "Fields and source evidence"
                                            ),
                                          ]),
                                          _c("pre", [
                                            _vm._v(_vm._s(_vm.json(version))),
                                          ]),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    }),
                    _vm._v(" "),
                    _c("details", { staticClass: "small mt-2" }, [
                      _c("summary", [_vm._v("Source record provenance")]),
                      _c("pre", [
                        _vm._v(
                          _vm._s(_vm.json(_vm.sourceRecordMeta(sourceRecord)))
                        ),
                      ]),
                    ]),
                  ],
                  2
                )
              }
            ),
            _vm._v(" "),
            !(_vm.record.source_records || []).length
              ? _c("p", { staticClass: "text-muted" }, [
                  _vm._v("No supplier source records."),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.links.length
              ? _c("details", { staticClass: "mb-3" }, [
                  _c("summary", [_vm._v("Relationship evidence")]),
                  _c("pre", [_vm._v(_vm._s(_vm.json(_vm.links)))]),
                ])
              : _vm._e(),
          ]
        : [
            _c("p", { staticClass: "small text-muted" }, [
              _vm._v(
                "Administrator changes and disputed identities. Original source versions remain in Source records. All timestamps use UTC."
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "small" }, [
              _vm._v(
                "Record created " +
                  _vm._s(_vm.date(_vm.record.created_at)) +
                  " · " +
                  _vm._s(
                    _vm.record.origin === "manual" ? "Manual entry" : "Import"
                  )
              ),
            ]),
            _vm._v(" "),
            _vm.conflicts.length
              ? _c(
                  "section",
                  { staticClass: "mb-4" },
                  [
                    _c("h3", { staticClass: "h6" }, [
                      _vm._v("Identity conflicts"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.conflicts, function (conflict) {
                      return _c(
                        "div",
                        {
                          key: conflict.id,
                          staticClass: "border-bottom py-2 small",
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.label(conflict.status))),
                          ]),
                          _vm._v(
                            " · " +
                              _vm._s(_vm.date(conflict.since)) +
                              "\n        "
                          ),
                          _c("div", [
                            _vm._v(
                              "Original " +
                                _vm._s(
                                  _vm.identity(conflict.original_identity)
                                ) +
                                " · Incoming " +
                                _vm._s(_vm.identity(conflict.asserted_identity))
                            ),
                          ]),
                          _vm._v(" "),
                          conflict.resolution
                            ? _c("div", [
                                _vm._v(_vm._s(conflict.resolution.reason)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          conflict.status === "open" && _vm.canUpdate
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-outline-primary my-2",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("action", {
                                        kind: "resolve-conflict",
                                        conflict,
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Review conflict")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("details", [
                            _c("summary", [
                              _vm._v("Disputed evidence and resolution"),
                            ]),
                            _c("pre", [_vm._v(_vm._s(_vm.json(conflict)))]),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "mb-4" },
              [
                _c("h3", { staticClass: "h6" }, [_vm._v("Field corrections")]),
                _vm._v(" "),
                _vm._l(
                  _vm.record.corrections_history ||
                    _vm.record.corrections ||
                    [],
                  function (correction) {
                    return _c(
                      "div",
                      {
                        key: correction.id,
                        staticClass: "border-bottom py-2 small",
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.label(correction.field))),
                        ]),
                        _vm._v(
                          " · " +
                            _vm._s(
                              correction.origin === "manual_create"
                                ? "Initial manual value"
                                : "Correction"
                            ) +
                            "\n        "
                        ),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              correction.is_blank
                                ? "Left blank"
                                : _vm.text(correction.value)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.date(correction.set_at)) +
                              " · " +
                              _vm._s(correction.reason)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              correction.active
                                ? "Current correction"
                                : correction.cleared_at
                                ? `Removed ${_vm.date(correction.cleared_at)}`
                                : `Superseded ${_vm.date(
                                    correction.superseded_at
                                  )}`
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("details", [
                          _c("summary", [
                            _vm._v("Prior value, actor and audit"),
                          ]),
                          _c("pre", [_vm._v(_vm._s(_vm.json(correction)))]),
                        ]),
                      ]
                    )
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            (_vm.record.link_corrections_history || []).length
              ? _c(
                  "section",
                  { staticClass: "mb-4" },
                  [
                    _c("h3", { staticClass: "h6" }, [
                      _vm._v("Relationship corrections"),
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.record.link_corrections_history,
                      function (correction) {
                        return _c(
                          "div",
                          {
                            key: correction.id,
                            staticClass: "small border-bottom py-2",
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.role(correction.role))),
                            ]),
                            _vm._v(
                              " · " +
                                _vm._s(
                                  correction.is_no_target
                                    ? "Source relationship suppressed"
                                    : "Explicit target"
                                )
                            ),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.date(correction.set_at)) +
                                  " · " +
                                  _vm._s(correction.reason)
                              ),
                            ]),
                            _c("details", [
                              _c("summary", [
                                _vm._v("Target, prior value and audit"),
                              ]),
                              _c("pre", [_vm._v(_vm._s(_vm.json(correction)))]),
                            ]),
                          ]
                        )
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("h3", { staticClass: "h6" }, [_vm._v("Admin actions")]),
                _vm._v(" "),
                _vm._l(
                  _vm.provenance.admin_actions || [],
                  function (event, index) {
                    return _c(
                      "div",
                      {
                        key: event.id || index,
                        staticClass: "border-bottom py-2 small",
                      },
                      [
                        _c("strong", [_vm._v(_vm._s(_vm.label(event.action)))]),
                        _vm._v(" · " + _vm._s(_vm.date(event.created_at))),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              event.actor
                                ? event.actor.email || event.actor.user_id
                                : "Actor not recorded"
                            )
                          ),
                        ]),
                        _c("div", [_vm._v(_vm._s(event.reason))]),
                        _c("details", [
                          _c("summary", [_vm._v("Action details")]),
                          _c("pre", [_vm._v(_vm._s(_vm.json(event)))]),
                        ]),
                      ]
                    )
                  }
                ),
                _vm._v(" "),
                !(_vm.provenance.admin_actions || []).length
                  ? _c("p", { staticClass: "small text-muted" }, [
                      _vm._v("No administrator actions."),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }